import { render, staticRenderFns } from "./pent-box.vue?vue&type=template&id=53dd8240&scoped=true"
import script from "./pent-box.ts?vue&type=script&lang=ts&external"
export * from "./pent-box.ts?vue&type=script&lang=ts&external"
import style0 from "./pent-box.less?vue&type=style&index=0&id=53dd8240&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd8240",
  null
  
)

export default component.exports